import ds from 'Shared/ds';

export default class SearchApi
{
    static suggestions = query => {
        var data = {
            q: query
        };

        return ds.get(this.#const.SUGGESTIONS, data);
    }

    static products = data => {
        // die Suche kann einen Array für Tags / Flags enthalten, javascript serializiert das data-objekt standardmäßig nur in den letzten Wert des Arrays
        var params = new URLSearchParams(data);


        return ds.get(this.#const.PRODUCTS + '?' + params.toString());
    }

    static variants = data => ds.get(this.#const.VARIANTS, data);

    static byKey = query => ds.get(this.#const.VARIANT, { q: query });

    static #const = {
        SUGGESTIONS: "/search/complete",
        PRODUCTS: "/catalog/products",
        VARIANTS: "/catalog/variants",
        VARIANT: "/catalog/search/variant"
    }
}